import { useMemo } from 'react'
import { useAuth } from 'torqcloud-ui'

import { useOrganization } from '@/contexts/OrganizationContext'
import { canAccessOrganizationSettings, canManageOrganizationMembership } from '@/utils/organizationSettingsAccess'

export default function useOrganizationSettingsAccess() {
  const { organizations } = useAuth()
  const { currentOrganizationId } = useOrganization()

  return useMemo(() => {
    const currentOrganization = organizations.find(organization => organization.organization_id === currentOrganizationId) ?? null

    return {
      currentOrganization,
      canAccessOrganizationSettings: canAccessOrganizationSettings(currentOrganization),
      canManageOrganizationMembership: canManageOrganizationMembership(currentOrganization),
    }
  }, [currentOrganizationId, organizations])
}
